module.exports = __webpack_public_path__ + "static/media/flow.2e0ed9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/flow.png
// module id = 729
// module chunks = 0